import 'react-bootstrap-typeahead/css/Typeahead.css';
import _ from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FakeLink } from '@/core/FakeLink';
import { PathComponents } from '@/utilities/PathComponents.atom';
import { faToggleOn } from '@seeqdev/icons/fa-pro-solid-svg-icons';
import { faToggleOff } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import { Icon, Modal } from '@seeqdev/qomponents';

export interface AssetReplaceModalProps {
  onAssetSelection: (item: { id: string; name: string }) => void;
  onClose: () => void;
  selectedAsset: { id: string; name: string } | undefined;
  availableAssets: any[];
  likelySwapOuts: { id: string; name: string; disabled: boolean }[];
  size: 'sm' | 'lg';
  isSwappingScalingTableRow?: boolean;
}

export const AssetReplaceModal = ({
  onAssetSelection,
  onClose,
  selectedAsset,
  availableAssets,
  likelySwapOuts,
  size,
  isSwappingScalingTableRow = false,
}: AssetReplaceModalProps) => {
  const [showFullPaths, setShowFullPaths] = useState(
    !isSwappingScalingTableRow ? _.uniqBy(likelySwapOuts, 'name').length < likelySwapOuts.length : false,
  );
  const hasSelectedAsset = !!selectedAsset;

  const { t } = useTranslation();

  return (
    <Modal
      size={size}
      open={true}
      onClose={onClose}
      testId={isSwappingScalingTableRow ? 'scalingRowReplaceModal' : 'assetReplaceModal'}
      title={t(`${isSwappingScalingTableRow ? 'SCALING_ROW_REPLACE.TITLE' : 'ASSET_REPLACE.TITLE'}`)}
      hideSubmitButton={true}
      cancelButtonLabel={t('CANCEL')}>
      <div>
        <div className="tw:pb-sq-10">
          {t(`${isSwappingScalingTableRow ? 'SCALING_ROW_REPLACE.PROMPT' : 'ASSET_REPLACE.PROMPT'}`, {
            hasSelectedAsset,
            selectedAsset: selectedAsset?.name,
          })}
        </div>
        {!isSwappingScalingTableRow && (
          <>
            {t('SWAPS.SHOW_FULL_PATH')}
            <span className="tw:ml-sq-5 tw:pr-sq-5 tw:pl-sq-5">
              {showFullPaths ? (
                <a className="force-link-color" onClick={() => setShowFullPaths(false)}>
                  <Icon icon={faToggleOn} extraClassNames="mr4" large={true} />
                  {t('CONFIGURATION.ON')}
                </a>
              ) : (
                <a className="force-link-color" onClick={() => setShowFullPaths(true)}>
                  <Icon icon={faToggleOff} extraClassNames="mr4" large={true} />
                  {t('CONFIGURATION.OFF')}
                </a>
              )}
            </span>
          </>
        )}
        {showFullPaths
          ? _.map(availableAssets, (asset) => (
              <div className="tw:pb-sq-10 tw:pl-sq-10" key={asset.id}>
                <PathComponents
                  asset={asset}
                  actionOnComponent={() => {
                    onClose();
                    onAssetSelection(asset);
                  }}
                />
              </div>
            ))
          : _.map(likelySwapOuts, (asset) => (
              <div className="tw:pb-sq-10 tw:pl-sq-10" key={asset.id}>
                <FakeLink
                  extraClassNames="stronger nowrap"
                  onClick={() => {
                    onClose();
                    onAssetSelection(asset);
                  }}>
                  {asset.name}
                </FakeLink>
              </div>
            ))}
      </div>
    </Modal>
  );
};
